var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ToolbarItemContainer', {
    attrs: {
      "iconFile": _vm.handleIcon(),
      "title": _vm.handleTitle(),
      "needDialog": false,
      "iconWidth": "20px",
      "iconHeight": "20px"
    },
    on: {
      "onIconClick": _vm.onIconClick
    }
  }, [_c('div', {
    class: ['video-upload', !_vm.isPC && 'video-upload-h5']
  }, [_c('input', {
    ref: "inputRef",
    attrs: {
      "title": _vm.props.title || _vm.TUITranslateService.t('视频'),
      "type": "file",
      "data-type": "video",
      "accept": "video/*"
    },
    on: {
      "change": _vm.sendVideoInWeb
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }